<template>
  <div class="userinfo-container">
    <el-form :inline="true" :model="filters">
      <el-form-item>
        <el-input
          size="small"
          v-model="filters.search"
          placeholder="登录名/姓名/手机号"
          style="width: 200px"
          @keyup.native.enter="getUserList"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="success"
          icon="el-icon-plus"
          @click="create"
          >创建</el-button
        >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getUserList"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <div class="table-div">
      <!--列表-->
      <el-table
        stripe
        border
        size="mini"
        :data="users"
        highlight-current-row
        expand-on-click-node="false"
        style="width: 100%"
        height="100%"
      >
        <el-table-column
          prop="Name"
          sortable
          label="登录名"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="Actor.Name"
          sortable
          show-overflow-tooltip
          label="所属店铺"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="RealName"
          sortable
          label="真实姓名"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="Mobile"
          sortable
          label="手机号"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="NickName"
          sortable
          label="微信昵称"
          :show-overflow-tooltip="true"
          width="120"
        ></el-table-column>
        <el-table-column prop="HeadImage" label="微信头像" width="80">
          <template slot-scope="scope">
            <viewer>
              <img
                v-if="scope.row.HeadImage"
                :src="'https://mjapi.codetime.com.cn/' + scope.row.HeadImage"
                :key="scope.row.HeadImage"
                height="30"
                width="30"
              />
            </viewer>
          </template>
        </el-table-column>
        <el-table-column
          prop="IsActive"
          sortable
          label="允许登录"
          :show-overflow-tooltip="true"
          width="120"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.IsActive"
              @change="handleSave(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="Description"
          sortable
          label="备注"
          :show-overflow-tooltip="true"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="InsertTime"
          sortable
          label="创建时间"
          width="130"
        >
          <template slot-scope="scope">
            {{ format.dateTimeFormat(scope.row.InsertTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.Name != 'administrator'"
              size="small"
              @click="update(scope.row)"
              >修改</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.Name != 'administrator'"
              size="small"
              @click="showChangePwdForm(scope.row)"
              >修改密码</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.Name != 'administrator'"
              size="small"
              @click="remove(scope.row)"
              >删除</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.Name != 'administrator'"
              size="small"
              @click="role(scope.row)"
              >所属角色</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="pageSizesList"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="pageIndex"
      ></el-pagination>
    </div>
    <!--新增界面-->
    <div v-if="addFormVisible">
      <el-dialog
        v-dragDialog
        :title="textMap[dialogStatus]"
        :visible.sync="addFormVisible"
        width="500px"
        :close-on-click-modal="false"
      >
        <el-form
          :model="addForm"
          ref="dataForm"
          label-width="100px"
          :rules="addFormRules"
        >
          <el-form-item label="隶属店铺" prop="Actor">
            <tenantSelector
              ref="tenantSelector"
              :onlyShop="false"
              v-model="addForm.Actor"
            />
          </el-form-item>
          <el-form-item label="登录名" prop="Name">
            <el-input
              v-model="addForm.Name"
              size="small"
              auto-complete="off"
              v-bind:readonly="readonlyUserName"
              placeholder="请输入登录名"
            ></el-input>
          </el-form-item>
          <el-form-item label="真实姓名：" prop="RealName">
            <el-input
              v-model="addForm.RealName"
              size="small"
              auto-complete="off"
              placeholder="请输入真实姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="Mobile">
            <el-input
              v-model="addForm.Mobile"
              size="small"
              auto-complete="off"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="密码："
            prop="Password"
            v-if="dialogStatus == 'create'"
          >
            <el-input
              v-model="addForm.Password"
              size="small"
              type="password"
              auto-complete="off"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="确认密码："
            prop="Password2"
            v-if="dialogStatus == 'create'"
          >
            <el-input
              v-model="addForm.Password2"
              type="password"
              size="small"
              auto-complete="off"
              placeholder="请确认密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="Description">
            <el-input
              v-model="addForm.Description"
              type="textarea"
              auto-complete="off"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addFormVisible = false">取消</el-button>
          <el-button
            v-if="dialogStatus == 'create'"
            type="primary"
            @click="createSubmit"
            >提交</el-button
          >
          <el-button v-else type="primary" @click="updateSubmit"
            >提交</el-button
          >
        </div>
      </el-dialog>
    </div>
    <powerManager ref="powerManager" :showOption="true"></powerManager>
    <userRoleView ref="userRoleView"></userRoleView>
    <ChangePwd ref="pwdForm" />
  </div>
</template>
<script>
import { getPageList, save, del } from "@/api/setting/member";
import ChangePwd from "@/components/changePwd";
import powerManager from "@/components/powerManager";
import userRoleView from "@/components/userRoleView";
import imageUploader from "@/components/imageUploader";
import tenantSelector from "@/components/tenantSelector";
export default {
  components: {
    ChangePwd: ChangePwd,
    powerManager: powerManager,
    userRoleView: userRoleView,
    imageUploader: imageUploader,
    tenantSelector: tenantSelector,
  },
  props: {},
  data() {
    const pwdValidator1 = (rule, value, callback) => {
      if (!value || value === "") {
        callback(new Error("请输入密码"));
      } else if (this.addForm.Password2 != "") {
        this.$refs.dataForm.validateField("Password2");
        callback();
      } else {
        callback();
      }
    };
    const pwdValidator2 = (rule, value, callback) => {
      if (!value || value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.addForm.Password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    let mobileValidator = (rule, value, callback) => {
      if (value === "" || !value) {
        callback();
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (!reg.test(value)) {
          callback(new Error("手机号码格式不符合规范"));
        }
      }
      callback();
    };
    let emailValidator = (rule, value, callback) => {
      if (value === "" || !value) {
        callback();
      } else {
        let temp = /^[\w.\-]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$/;
        //let tempOne = /^[A-Za-zd]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/;
        if (value && !temp.test(value)) {
          callback(new Error("邮箱格式不符合规范"));
        }
      }
      callback();
    };
    return {
      filters: {
        Name: "",
      },
      readonlyUserName: false,
      users: [],
      actors: [],
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      pageSizesList: [10, 15, 20, 30, 50],
      dialogStatus: "",
      addFormVisible: false,
      addLoading: false,
      textMap: {
        update: "修改用户",
        create: "新增用户",
      },
      addForm: {
        Key: "",
        Name: "",
        RealName: "",
        Mobile: "",
        Actor: "",
        MemberType: "",
        Password: "",
        Password2: "",
        Description: "",
      },
      addFormRules: {
        Actor: [{ required: true, message: "请选择所属", trigger: "change" }],
        Name: [
          { required: true, message: "用户名不能为空", trigger: "change" },
        ],
        Mobile: [
          { required: true, message: "手机号不能为空", trigger: "change" },
        ],
        RealName: [
          { required: true, message: "真实姓名不能为空", trigger: "change" },
        ],
        Actor: [{ required: true, message: "请选择所属", trigger: "change" }],
        Password: [
          { required: true, validator: pwdValidator1, trigger: "change" },
        ],
        Password2: [
          { required: true, validator: pwdValidator2, trigger: "change" },
        ],
      },
      availableShops: [],
      shopFormVisible: false,
      shopForm: {},
    };
  },
  methods: {
    handleSave(row) {
      save(row)
        .then((response) => {
          if (response) {
            this.msg.successMsg("操作成功");
          }
        })
        .catch((ex) => {
          this.msg.errorMsg("操作失败");
          row.IsActive = !row.IsActive;
        });
    },
    create() {
      this.dialogStatus = "create";
      this.addFormVisible = true;
      this.readonlyUserName = false;
      (this.addForm = {
        Key: "",
        Name: "",
        IDName: "",
        Actor: { Key: "" },
        Description: "",
      }),
        this.$nextTick(() => {
          this.$refs["dataForm"].clearValidate();
        });
    },
    createSubmit: function () {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let para = Object.assign({}, this.addForm);
          save(para).then((response) => {
            if (response) {
              this.msg.successMsg("操作成功");
              this.addFormVisible = false;
              this.getUserList();
            }
          });
        }
      });
    },
    update(row) {
      this.addForm = Object.assign({}, row); // copy obj
      if (this.addForm.Name == "administrator") this.readonlyUserName = true;
      else this.readonlyUserName = false;
      this.dialogStatus = "update";
      this.addForm.MemberType = this.config.memberTypes.find(
        (r) => r.value === this.addForm.MemberType
      ).key;
      this.addFormVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    updateSubmit: function () {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.addForm);
          save(data).then((response) => {
            if (response) {
              this.msg.successMsg("操作成功");
              this.addFormVisible = false;
              this.getUserList();
            }
          });
        }
      });
    },
    remove: function (row) {
      let userName = row.Name;
      if (userName == "administrator") {
        this.msg.SuccessMsg("administrator是超级管理员账号，不能删除！");
        return;
      }
      this.$confirm("确认删除用户" + userName + "吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          let data = { Key: row.Key };
          del(data).then((response) => {
            if (response) {
              this.msg.successMsg("操作成功");
              this.getUserList();
            }
          });
        })
        .catch(() => {});
    },

    showChangePwdForm(row) {
      this.$refs.pwdForm.showForm(row.Name);
    },

    role(row) {
      this.$refs.userRoleView.show(row.Key);
    },

    power(row) {
      this.$refs.powerManager.showManager(row.Key);
    },

    getUserList: function () {
      let data = {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        search: this.filters.search,
        actor: "",
      };
      getPageList(data).then((response) => {
        if (response) {
          this.users = response.Items;
          this.total = response.total || response.Items.length;
        }
      });
    },

    handleSizeChange(val) {
      var pageSize = `${val}`;
      this.pageIndex = 1;
      this.pageSize = parseInt(pageSize);
      this.$nextTick(() => this.getUserList());
    },

    handleCurrentChange(val) {
      this.pageIndex = `${val}`;
      this.getUserList();
    },
    handleSetShops() {},
  },
  mounted() {
    this.getUserList();
  },
};
</script>
<style lang='scss' scoped>
.userinfo-container {
  height: 100%;

  .table-div {
    height: calc(100% - 110px);
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }
}

/deep/.el-dialog {
  margin-top: 10px !important;
}
</style>
